import { Text, useDisclosure, useToast } from '@chakra-ui/react';
import { MenuItem } from 'components/v4';
import { TbTrash } from 'react-icons/tb';
import { IconComponent } from './IconComponent';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import path from '@/routes/constants';
import OverrideLimitModal from 'components/modal/OverrideLimitModal';
import { PlatformEnums } from '@/utils/platforms';

// API
import postOverrideLimit from 'API/Service/postOverrideLimit';
const walkthroughIdPrefix = '/dashboard-services/card';

const MicrosoftGraphMenuItems = ({
    accountScope,
    serviceObj,
    cardStatus,
    darkMode,
    handleGrantAccess,
    service,
    data,
}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const isMigrateToNewSync =
        serviceObj?.platformID === PlatformEnums.TEAMS && // msCommercialAppAuth
        !serviceObj?.msGraphAppInstanceID && // no appauth instance id
        serviceObj?.lastAccessSuccess && // has login before
        serviceObj?.statusDisplay?.statusDisplayLevel === 0; // is healthy status
    const toast = useToast();
    const [status, setStatus] = useState('idle');
    const handlePostOverrideLimit = async () => {
        setStatus('loading');
        const res = await postOverrideLimit(data.id);
        if (res.status === 200) {
            setStatus('success');
            toast({
                title: 'Override Limit',
                description:
                    'Override limit has been submitted for processing.',
                status: 'success',
                duration: 5000,
                isClosable: true,
            });
            onClose();
        } else {
            setStatus('error');
            toast({
                title: 'Override Limit',
                description:
                    'Unable to Process Request. One or more validation errors occurred.',
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        }
    };

    // submit Override Limit modal
    const handleSubmit = (e) => {
        e.preventDefault();
        handlePostOverrideLimit();
    };
    return (
        <>
            <Link
                to={`${path.SERVICES_APP_AUTH}/${data.id}/edit`}
                state={service}
                className="hover:text-inherit hover:!no-underline">
                <MenuItem
                    icon={
                        <IconComponent
                            icon="Edit"
                            color={darkMode ? 'white' : 'black'}
                        />
                    }
                    data-walkthroughid={`${walkthroughIdPrefix}/${service.serviceType}/edit-appAuth`}>
                    <Text marginBottom="0">Edit AppAuth</Text>
                </MenuItem>
            </Link>
            {/* Override Delete Limit */}
            {accountScope >= 80 && (
                <MenuItem
                    icon={<TbTrash color={darkMode ? 'white' : 'black'} />}
                    onClick={(e) => {
                        e.stopPropagation();
                        onOpen();
                    }}
                    data-walkthroughid={`${walkthroughIdPrefix}/${service.serviceType}/override-deleteLimit`}>
                    <Text marginBottom="0">Override Delete Limit</Text>
                </MenuItem>
            )}

            {/* Migration to New Sync */}
            {cardStatus?.grantAccess ? (
                <MenuItem
                    icon={
                        <IconComponent
                            icon="Settings"
                            color={darkMode ? 'white' : 'black'}
                        />
                    }
                    onClick={(e) => {
                        e.stopPropagation();
                        handleGrantAccess();
                    }}
                    data-walkthroughid={`${walkthroughIdPrefix}/${service.serviceType}/provide-access`}>
                    <Text marginBottom="0">Grant Access</Text>
                </MenuItem>
            ) : (
                isMigrateToNewSync && (
                    <MenuItem
                        icon={
                            <IconComponent
                                icon="Settings"
                                color={darkMode ? 'white' : 'black'}
                            />
                        }
                        onClick={(e) => {
                            e.stopPropagation();
                            handleGrantAccess();
                        }}
                        data-walkthroughid={`${walkthroughIdPrefix}/${service.serviceType}/provide-access`}>
                        <Text marginBottom="0">Migrate to New Sync</Text>
                    </MenuItem>
                )
            )}
            <OverrideLimitModal
                isOpen={isOpen}
                onClose={onClose}
                status={status}
                handleSubmit={handleSubmit}
            />
        </>
    );
};

export default MicrosoftGraphMenuItems;
